/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccesscontrolPermissionsId200,
  GetApiV1AccesscontrolPermissionsId401,
  GetApiV1AccesscontrolPermissionsId404,
  GetApiV1AccesscontrolPermissionsId500,
  GetApiV1AccesscontrolPermissionsIdPathParams,
  GetApiV1AccesscontrolPermissionsIdQueryResponse,
} from "../../types/accessControlPermissionsController/GetApiV1AccesscontrolPermissionsId.ts";
import { userControllerPermissionViewModelSchema } from "../userControllerPermissionViewModelSchema.ts";

export const getApiV1AccesscontrolPermissionsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1AccesscontrolPermissionsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccesscontrolPermissionsId200Schema = z.lazy(
  () => userControllerPermissionViewModelSchema,
) as unknown as ToZod<GetApiV1AccesscontrolPermissionsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccesscontrolPermissionsId401Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1AccesscontrolPermissionsId404Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccesscontrolPermissionsId500Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsId500>;

export const getApiV1AccesscontrolPermissionsIdQueryResponseSchema = z.lazy(
  () => getApiV1AccesscontrolPermissionsId200Schema,
) as unknown as ToZod<GetApiV1AccesscontrolPermissionsIdQueryResponse>;
